import {
  AllocationRuleDto,
  AllocationRulesApi,
  CarrierType,
  CarrierVisitDirection,
  DeleteAllocationRuleRequest,
  UpsertAllocationRuleRequest,
  UpsertTemplateAllocationRuleRequest,
} from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

export class AllocationRuleService {
  private readonly httpClient = createApiClient(AllocationRulesApi)

  async loadAllocationRules(
    isTemplate: boolean,
    id?: string,
    direction?: CarrierVisitDirection,
    carrierType?: CarrierType,
    carrierVisitId?: number,
  ): Promise<AllocationRuleDto[]> {
    const { data } = await this.httpClient.getAllocationRules(
      isTemplate,
      id,
      direction,
      carrierType,
      carrierVisitId,
    )
    return data.allocationRules
  }

  async upsertAllocationRuleTemplate(request: UpsertTemplateAllocationRuleRequest) {
    await this.httpClient.upsertTemplateAllocationRule(request)
  }

  async upsertAllocationRule(request: UpsertAllocationRuleRequest) {
    await this.httpClient.upsertAllocationRule(request)
  }

  async deleteAllocationRule(request: DeleteAllocationRuleRequest): Promise<void> {
    await this.httpClient.deleteAllocationRule(request)
  }
}

export const allocationRuleService = new AllocationRuleService()
